/** A running repeat of a callback; stop it once the work it animates is over. */
export interface Ticker {
  stop(): void
}

/** Calls `onTick` every `periodMs`, from a worker when the browser offers one, else a page timer. */
export function startTicker(periodMs: number, onTick: () => void): Ticker {
  return startWorkerTicker(periodMs, onTick) ?? startPageTicker(periodMs, onTick)
}

function startWorkerTicker(periodMs: number, onTick: () => void): Ticker | null {
  if (typeof Worker !== 'function') return null
  try {
    const worker = new Worker(new URL('./ticker.worker.ts', import.meta.url), { type: 'module' })
    worker.addEventListener('message', onTick)
    worker.postMessage(periodMs)
    return { stop: () => worker.terminate() }
  } catch {
    return null
  }
}

function startPageTicker(periodMs: number, onTick: () => void): Ticker {
  const timer = setInterval(onTick, periodMs)
  return { stop: () => clearInterval(timer) }
}
